module.exports = {
  worker_take_job: 'Исполнитель взял смену',
  worker_cancelled_job: 'Исполнитель отменил подработку',
  employer_created_order: 'Заказчик опубликовал заказ',
  employer_deleted_order: 'Заказчик отменил заказ',
  payment_failed: 'Платёж не прошёл',
  support_created: 'Заказчик/исполнитель сообщил о проблеме',
  document_uploaded: 'Загружен новый документ',
  receipt_added: 'Добавлен новый чек',
  no_checkin: 'Работник не отметился на смене в течение 30 минут, требуется замена',
  interview_added: 'Добавлено интервью',
  worker_booked_job: 'Гигер забронировал смену в приложении',
  moderation_for_coordinator: 'Заявка на модерацию назначения гигера на смену',
};
